import type { ValueOf } from '@evc/web-components';

export const permissions = {
  // CORE API
  LICENSING_CREATE_OR_UPDATE: 'Platform_PublicWeb_Core_Licensing_CreateOrUpdate',
  LICENSING_DELETE: 'Platform_PublicWeb_Core_Licensing_Delete',
  LICENSING_READ: 'Platform_PublicWeb_Core_Licensing_Read',
  ORGANIZATION_CHANGE_ROLE: 'Platform_PublicWeb_Core_Organization_ChangeRole',
  ORGANIZATION_CREATE_LINK: 'Platform_PublicWeb_Core_Organization_CreateLink',
  ORGANIZATION_REMOVE_LINK: 'Platform_PublicWeb_Core_Organization_RemoveLink',
  ORGANIZATION_DELETE: 'Platform_PublicWeb_Core_Organization_Delete',
  ORGANIZATION_DELETE_USER: 'Platform_PublicWeb_Core_Organization_DeleteUser',
  ORGANIZATION_DELETE_USER_INVITATION: 'Platform_PublicWeb_Core_Organization_DeleteUserInvitation',
  ORGANIZATION_INVITE_USER: 'Platform_PublicWeb_Core_Organization_InviteUser',
  ORGANIZATION_READ: 'Platform_PublicWeb_Core_Organization_Read',
  ORGANIZATION_UPDATE: 'Platform_PublicWeb_Core_Organization_Update',
  PRODUCT_CATEGORY_READ: 'Platform_PublicWeb_Core_ProductCategory_Read',
  PRODUCT_READ: 'Platform_PublicWeb_Core_Product_Read',
  // DEVICE API
  DEVICE_READ: 'Platform_PublicWeb_Device_Devices_Read',
  DEVICE_REGISTER: 'Platform_PublicWeb_Device_Devices_Register',
  // STORAGE API
  STORAGE_READ: 'Platform_PublicWeb_Storage_Read',
  STORAGE_CREATE_UPDATE: 'Platform_PublicWeb_Storage_CreateOrUpdate',
  STORAGE_DELETE: 'Platform_PublicWeb_Storage_Delete',
  STORAGE_PERMANENT_DELETE: 'Platform_PublicWeb_Storage_PermanentDelete',
  STORAGE_UPLOAD: 'Platform_PublicWeb_Storage_Upload',
  STORAGE_DOWNLOAD: 'Platform_PublicWeb_Storage_Download',
  STORAGE_AI_READ: 'Platform_PublicWeb_Storage_AI_Read',
  STORAGE_AI_CREATE_JOB: 'Platform_PublicWeb_Storage_AI_CreateJob',
} as const;

export type Permission = ValueOf<typeof permissions>;
